<template>
  <div class="search-filter-empty-state">
    <h2>{{ headline }}</h2>
    <p>{{ subline }}</p>
  </div>
</template>
<script>
export default {
  name: "ResultsEmptyState",
  props: {
    headline: {
      type: String,
      required: true,
    },
    subline: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.search-filter-empty-state {
  @include font-family("body");

  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  align-self: stretch;

  padding: 25px 0;

  color: var(--search-filter-text-color);

  h2 {
    @include scale-fonts("heading-1");
    @include font-family("heading");
  }

  p {
    @include scale-fonts("body");
  }
}
</style>
